import { useEffect, useState } from "react";
import {
  ExperimentDataPoint,
  LnpDataPoint,
} from "../components/dashboard/types";
import { Backend } from "../url";

interface UseUmapDataReturn {
  lnpData: LnpDataPoint[];
  experimentData: ExperimentDataPoint[];
  loading: boolean;
  error: Error | null;
}

export const useUmapData = (): UseUmapDataReturn => {
  const [lnpData, setLnpData] = useState<LnpDataPoint[]>([]);
  const [experimentData, setExperimentData] = useState<ExperimentDataPoint[]>(
    []
  );
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const lnpResponse = await fetch(`${Backend}/search/lnp_umap`);
        const experimentResponse = await fetch(`${Backend}/search/il_umap`);

        if (!lnpResponse.ok || !experimentResponse.ok) {
          throw new Error("Error fetching data");
        }

        const lnpJson = (await lnpResponse.json()) as LnpDataPoint[];
        const experimentJson =
          (await experimentResponse.json()) as ExperimentDataPoint[];

        setLnpData(lnpJson);
        setExperimentData(experimentJson);
      } catch (err) {
        setError(
          err instanceof Error ? err : new Error("Unknown error occurred")
        );
        console.error("Error fetching data:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  return { lnpData, experimentData, loading, error };
};
